import React from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom"
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

import BankReconciliation from "./pages/BankReconciliation/BankReconciliation"
import Login from "./pages/Login"
import ForgottenPassword from "./pages/ForgottenPassword"
import PowerBITable from "./pages/PowerBITable"
import Dashboarding from "./pages/Dashboarding/Dashboarding"

import "semantic-ui-css/semantic.min.css"
import "./App.css"
import "./tailwind.output.css"
import "./style/style.css"

import "./loaders/setupAxios"

import ToasterProvider from "./contexts/Toaster/ToasterProvider"
import DatabaseProvider from "./contexts/Database/DatabaseProvider"
import AuthenticationProvider from "./contexts/Authentication/AuthenticationProvider"

const queryClient = new QueryClient()

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticationProvider>
        <ToasterProvider>
          <DatabaseProvider>
            <Router>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/PowerBITable" element={<PowerBITable />} />
                <Route path="/Dashboarding" element={<Dashboarding />} />
                <Route path="/BankReconciliation" element={<BankReconciliation />} />
                <Route path="/ForgottenPassword" element={<ForgottenPassword />} />
              </Routes>
            </Router>
          </DatabaseProvider>
        </ToasterProvider>
      </AuthenticationProvider>
    </QueryClientProvider>
  )
}

export default App
